import React, {useEffect, useState} from "react";
import {useTranslation} from "react-i18next";
import PropTypes from "prop-types";
import {Form} from "react-final-form";
import {shallowEqual, useDispatch, useSelector} from "react-redux";
import {FiDownload, FiImage, MdFormatListBulleted} from "react-icons/all";
import EnigooModal from "../../../MyComponent/Modal/EnigooModal";
import Widget from "../../../components/widget";
import ActionDaysSelect from "./Form/ActionDaysSelect";
import {apiGetActionById} from "../Action/Actions";
import {EnigooSelect} from "../../../MyComponent/EnigooSelect";
import CogoToast from "cogo-toast";
import {apiExportUserImage} from "./Actions";

const ImageExportModal = ({selectedRows, actionId,
                                 selectAll}) => {
    const {t} = useTranslation();
    let [saving, setSaving] = useState(false);
    let [loading, setLoading] = useState(false);
    let [action, setAction] = useState(null);
    let [open, setOpen] = useState(false);
    let [selectData, setSelectData] = useState([]);
    const dispatch = useDispatch();

    let submit = null;

    useEffect(() => {
        // load only when the modal is opened - it is mounted (hidden) in the options dropdown all the time
        if (!open || !actionId) return;
        setLoading(true);
        apiGetActionById(actionId, (data) => {
            setAction(data);
            setLoading(false);
        }, (err) => {
            setAction(null);
            setLoading(false);
        })
    }, [actionId, open]);

    useEffect(() => {
        let array = [];
        array.push({
            id: "ACC_IMG",
            name: t("accreditation.image")
        })
        if(action && action.customField){
            action.customField.map(item => {
                if(item.customFieldType.type === "IMAGE"){
                    array.push({
                        id: item.id,
                        name: item.name
                    })
                }
            })
        }
        setSelectData(array);
    },[action])

    const {palettes, actualAction, filterUser} = useSelector(
        (state) => ({
            palettes: state.reducerAdmin.palettes,
            actualAction: state.reducerAdmin.actualAction,
            filterUser: state.reducerAdmin.filterUser
        }),
        shallowEqual
    )
    let {filterData} = {
        ...filterUser
    }

    const downloadData = (data) => {
        const blob = new Blob([data.data], { type: 'application/zip' });
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = data.fileName;
        link.click();
        link.remove();
        setSaving(false);
        onClose();
    }

    const onSave = (values) => {
        setSaving(true);
        let data = {};
        data.userId = selectedRows;
        data.actualAction = actualAction.actualAction;
        data.actionId = actionId;
        data.filterData = filterData;
        data.all = selectAll;
        data.type = values.type;

        console.log(data);
        apiExportUserImage(data,(data)=>{

            downloadData(data);
        },(err)=>{
            const { status, data } = err.response;
            let text = "ERROR";
            let json = {error:"ERROR"};
            try {
                // protože je to blob, přečteme ho jako text
                text = data.text();
                json = JSON.parse(text);
                console.log("Status:", status);
                console.log("Server error:", json.error);
            } catch (e) {
                text = "ERROR";
                json = {error:"ERROR"};
                // kdyby to nebyl JSON
                console.log("Status:", status);
                console.log("Raw error data:", data);
            }
            CogoToast.error(t("accreditation.imageExportError"))
            setSaving(false);
        })
    }

    const onClose = () =>{
        setOpen(false);
    }
    const onOpen = () => {
        setOpen(true);
    }

    if (action) {
        return (
            <EnigooModal open={open} onOpen={onOpen} onClose={onClose} buttonText={t("basics.exportImage")}
                         title={t("basics.exportImage")}
                         disabled={!selectedRows || selectedRows.length === 0 || loading || saving}
                         buttonIcon={<FiImage/>} type={"dropdown"} cancelText={t("basics.close")}
                         onSave={()=>submit()} saveIcon={<FiDownload/>} saveText={t("basics.export")}>
                <Widget>
                    <div className="flex flex-col">
                        <Form onSubmit={onSave}
                              render={({handleSubmit}) => {
                                  submit = handleSubmit;
                                  return (
                                      <>
                                          <EnigooSelect label={t("basics.type")+": *"}
                                                        name={"type"}
                                                        inModal={true}
                                                        items={selectData}
                                          />
                                      </>
                                  );
                              }}
                        />
                    </div>

                </Widget>
            </EnigooModal>
        )
    } else {
        return <></>
    }
}
ImageExportModal.propTypes = {
    selectedRows: PropTypes.array,
    actionId: PropTypes.number
}
export default ImageExportModal;
